import React, { useCallback, useEffect, useMemo } from 'react';
import { DefaultQueryParams, isMobile, MainWr, parseQuery } from '@pascal/pascal-core';
import { popupStore } from '@pascal/pascal-core/shared/core/store';
import { BrowserRouter } from 'react-router-dom';
import { Factory } from './core';
import { WebGame } from './conatiners/webGame';
import { MobileGame } from './conatiners/mobileGame';
import { gameService } from './services';
import { RoutePaths } from './enums/routes';
import { BET_SHOP_GAME_ID, TURBO_GAME_ID } from './enums/constants';
import BetShopGame from './conatiners/betShopGame';

function App() {
  const { [DefaultQueryParams.GameId]: gameId, [DefaultQueryParams.BetId]: betId } = parseQuery(
    window.location.search
  );
  const isTurbo = +gameId === TURBO_GAME_ID;
  const isBetShop = +gameId === BET_SHOP_GAME_ID;
  const isBetId = !!betId;

  useEffect(() => {
    if (isBetShop) {
      const element = document.getElementById('root');
      element.classList.add('bet-shop');
    }
  }, [isBetShop]);

  const components = useMemo(
    () => [
      // {
      //   path: isTurbo || isBetShop || isBetId ? `${RoutePaths.lobby}lobby` : RoutePaths.lobby,
      //   element: <TableLobbyWr />,
      //   defaultRedirectComponent: !isTurbo && !isBetShop && !isBetId,
      // },
      {
        path: isTurbo ? RoutePaths.turbo : RoutePaths.game,
        element: isMobile() ? <MobileGame /> : <WebGame />,
        defaultRedirectComponent: isTurbo,
      },
      {
        path: RoutePaths.betShop,
        element: <BetShopGame />,
        defaultRedirectComponent: isBetShop,
      },
      {
        path: RoutePaths.replay,
        element: isMobile() ? <MobileGame isReplay /> : <WebGame isReplay />,
        defaultRedirectComponent: isBetId,
      },
    ],
    [isTurbo, isBetShop, isBetId]
  );

  const lostInternetConnection = useCallback(() => {
    // popupStore.open({ name: PopUps.ConnectionError });
    popupStore.onConnectionError(true);
  }, []);

  const reconnectInternet = useCallback(() => {
    gameService.socketRecursiveReconnecting();
  }, []);

  useEffect(() => {
    window.addEventListener('offline', lostInternetConnection);
    window.addEventListener('online', reconnectInternet);
    return () => {
      window.removeEventListener('offline', lostInternetConnection);
      window.removeEventListener('online', reconnectInternet);
    };
  }, [lostInternetConnection, reconnectInternet]);

  return (
    <BrowserRouter>
      <MainWr>
        <Factory components={components} />
      </MainWr>
    </BrowserRouter>
  );
}

export default App;
